//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    & > *:first-child {
        display: grid;
        place-items: center;
    }
    & span {
        font-size: 12px;
        font-weight: 490;
        color: var(--red-3);
    }
`;